import React, {Component} from "react";
import {Switch, Route} from "react-router-dom";
import List from "./list";
import Edit from "./edit";

export default class Index extends Component {
    render() {
        return (
                <Switch>
                    <Route exact path="/objects" component={List}/>
                    <Route path="/objects/create" component={Edit}/>
                    <Route path="/objects/:id" component={Edit}/>
                </Switch>
        )
    }
}
